// ExclamationMark.js
import React from "react";
import styled from 'styled-components';

const ExclamationMark = ({
  size = 24,
  color = "red",
  reason = "Requer ação",
  isActiveAndRequiresAction = false
}) => {
  return (
    <MarkContainer isActiveAndRequiresAction={isActiveAndRequiresAction}>
      <span style={{fontSize: 16}}>!</span><Reason>{reason}</Reason>
    </MarkContainer>
  );
};

const MarkContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => (props.isActiveAndRequiresAction ? "red" : "black")};
`;

const Reason = styled.span`
  margin-left: 5px;
  font-size: 12px;
  color: ${(props) => (props.isActiveAndRequiresAction ? "red" : "#555")};
`;

export default ExclamationMark;
